// extracted by mini-css-extract-plugin
module.exports = {"dot":"AnimatedPoint_dot__2Ssqt","selected":"AnimatedPoint_selected__3wPsP"};